import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';

const SLOTS = [
  { key: 'slot_1', label: 'Slot 1 — Large Left' },
  { key: 'slot_2', label: 'Slot 2 — Medium Top Centre' },
  { key: 'slot_3', label: 'Slot 3 — Small Bottom Left' },
  { key: 'slot_4', label: 'Slot 4 — Small Bottom Right' },
  { key: 'slot_5', label: 'Slot 5 — Tall Right' },
];

export default function FeaturedManager({ products, onUpdate }) {
  const [slots,  setSlots]  = useState({ slot_1: '', slot_2: '', slot_3: '', slot_4: '', slot_5: '' });
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);

  // Load current featured slot assignments from DB
  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from('featured_slots')
        .select('*')
        .single();
      if (data) {
        setSlots({
          slot_1: data.slot_1 || '',
          slot_2: data.slot_2 || '',
          slot_3: data.slot_3 || '',
          slot_4: data.slot_4 || '',
          slot_5: data.slot_5 || '',
        });
      }
    };
    load();
  }, []);

  const handleSave = async () => {
    setSaving(true);

    // Upsert into featured_slots table (single row)
    const { data: existing } = await supabase
      .from('featured_slots')
      .select('id')
      .limit(1)
      .single();

    if (existing?.id) {
      await supabase
        .from('featured_slots')
        .update(slots)
        .eq('id', existing.id);
    } else {
      await supabase
        .from('featured_slots')
        .insert([slots]);
    }

    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
    onUpdate();
  };

  const getProduct = (id) => products.find(p => p.id === id || p.id === parseInt(id));

  return (
    <div>
      <div className="ad__header">
        <div>
          <h1 className="ad__title">Featured Slots</h1>
          <p className="ad__subtitle">
            Assign a product to each of the 5 featured slots on the homepage.
          </p>
        </div>
        <button
          className="ad__add-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : saved ? '✓ Saved' : 'Save Featured'}
        </button>
      </div>

      {/* Slot selectors */}
      <div className="fm__slots">
        {SLOTS.map(({ key, label }) => {
          const selectedProduct = slots[key] ? getProduct(slots[key]) : null;
          return (
            <div key={key} className="fm__slot">
              {/* Slot preview image */}
              <div className="fm__slot-preview">
                {selectedProduct?.images?.[0] ? (
                  <img src={selectedProduct.images[0]} alt={selectedProduct.name} />
                ) : (
                  <div className="fm__slot-empty">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="#ccc" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                    <span>No product</span>
                  </div>
                )}
              </div>

              {/* Slot info */}
              <div className="fm__slot-info">
                <p className="fm__slot-label">{label}</p>
                {selectedProduct && (
                  <p className="fm__slot-current">
                    {selectedProduct.name} — {selectedProduct.brand}
                  </p>
                )}
                <select
                  className="fm__slot-select"
                  value={slots[key]}
                  onChange={e => setSlots(s => ({ ...s, [key]: e.target.value }))}
                >
                  <option value="">— Select a product —</option>
                  {products.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.name} ({p.brand})
                    </option>
                  ))}
                </select>
              </div>
            </div>
          );
        })}
      </div>

      {/* Live preview */}
      <div className="fm__preview-label">Live Preview</div>
      <div className="fm__preview-grid">
        {SLOTS.map(({ key, label }, i) => {
          const prod = slots[key] ? getProduct(slots[key]) : null;
          return (
            <div key={key} className="fm__preview-card">
              <div className="fm__preview-img">
                {prod?.images?.[0]
                  ? <img src={prod.images[0]} alt={prod.name} />
                  : <div className="fm__preview-placeholder">Empty</div>
                }
                <span className="fm__preview-num">Slot {i + 1}</span>
              </div>
              <p className="fm__preview-name">{prod?.name || '—'}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}